<template>
  <div class="wrapper">
    <div class="main-content general-activities">
      <section class="wf100 subheader" style="background: var(--dark)">
        <div class="container">
          <h2>وزارة الشؤون الاجتماعية والعمل</h2>
          <ul>
            <li><router-link to="/" href="#">الرئيسية</router-link></li>
            <li>عن الوزارة</li>
          </ul>
        </div>
      </section>

      <div class="main-content py-2">
        <div v-if="loading" class="container">
          <div class="row">
            <div class="col-lg-8 col-md-12">
              <b-skeleton animation="fade" width="25%"></b-skeleton>
              <b-skeleton animation="fade" width="100%"></b-skeleton>
              <b-skeleton animation="fade" width="100%"></b-skeleton>
              <b-skeleton animation="fade" width="100%"></b-skeleton>
              <b-skeleton animation="fade" width="100%"></b-skeleton>
            </div>
            <div class="col-lg-4 col-md-12">
              <div class="sidebar_contact">
                <!--Widget Start-->
                <div class="widget">
                  <b-skeleton animation="fade" width="100%"></b-skeleton>
                  <div class="about-widget inner">
                    <ul>
                      <b-skeleton animation="fade" width="100%"></b-skeleton>
                      <b-skeleton animation="fade" width="100%"></b-skeleton>
                      <b-skeleton animation="fade" width="100%"></b-skeleton>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container" v-else>
          <div class="row">
            <div class="col-lg-8 col-md-12">
              <h4 class="my-2 font-weight-bolder">عن الوزارة</h4>
              <div
                class="about-ministry"
                v-html="aboutMinistry.about_ministry.content"
                style="text-align: justify"
              ></div>
            </div>
            <div class="col-lg-4 col-md-12">
              <div class="sidebar_contact">
                <!--Widget Start-->
                <div class="widget">
                  <h4>معلومات التواصل</h4>
                  <div class="about-widget inner">
                    <ul>
                      <li
                        class="my-50"
                        v-for="item in aboutMinistry.contact_info"
                        :key="item.title"
                      >
                        <feather-icon
                          size="16"
                          :icon="item.title"
                          class="mx-50"
                        />
                        {{ item.content }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable, BNav, BNavItem, BSkeleton } from "bootstrap-vue";
import { mapGetters } from "vuex";
export default {
  components: {
    BTable,
    BNav,
    BNavItem,
    BSkeleton,
  },

  computed: {
    ...mapGetters("NgoHome/AboutMinistry", ["aboutMinistry", "loading"]),
  },
  created() {
    return this.$store.dispatch(`NgoHome/AboutMinistry/getAboutMinistry`);
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";

.h3-logo-row .h3-logo {
  padding: 2px !important;
  // text-align: justify;
}
.ministry-img {
  background-image: url("../../../../assets/images/ministry.jpg");
  background-size: cover;
}
.sidebar_contact {
  background: #fff;
  border-radius: 3px;
  margin-bottom: 40px;
  border: 1px solid #ececec;
  box-shadow: 0px 5px 10px 0 rgb(0 0 0 / 7%);
  li {
    font-size: medium;
  }
  h4 {
    border-bottom: 1px solid #ececec;
    padding: 0 20px;
    font-weight: 700;
    font-size: 18px;
    line-height: 53px;
    text-transform: uppercase;
  }
  div {
    padding: 15px;
  }
  // // .ministry_{
  // //   ul{
  //     li{
  //       list-style: disc;
  //     }
  // //   }
  // // }
}
.about-ministry {
  li {
    padding: 4px 0px;
    list-style-type: disc;
  }
  h6 {
    margin-bottom: 10px;
  }
}
</style>
